
<main>
    <div class="dashboard-list ">
        <div class="row">
            <div class="dashboard-box text-center cursorClass p-0" (click)="photosOrVideo(1)">
                <img class="" src="../../assets/img/image-file.png" />
                <h4>Photos</h4>
            </div>
            <div class="dashboard-box text-center cursorClass p-0" (click)="photosOrVideo(2)">
                <img class="" src="../../assets/img/video-folder.png" />
                <h4>Videos</h4>
            </div>
        </div>
    </div>
</main>